export var ManagerActionKind;
(function (ManagerActionKind) {
    ManagerActionKind["ModifyManager"] = "ModifyManager";
})(ManagerActionKind || (ManagerActionKind = {}));
